"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBSTITUTES = void 0;
const tab_1 = require("../../../tab");
exports.SUBSTITUTES = {
    description: 'Replaces values on {original_string} using N pair of parameters on {pair_to_replace} as key, value (key to search, value to replace)',
    arg_names: ['original_string', 'pairs_to_replace'],
    args_def: [
        {
            types: ['string'],
            required: true,
        },
        {
            types: ['string'],
            required: true,
            variadic: true,
        },
    ],
    args_description: [
        'string to be searched and replaced',
        'variadic parameter used as key value pairs to find and replace (N pairs can be sent). If variadic parameters count is an odd number, last received key will not be replaced',
    ],
    return_type: tab_1.ColumnType.STRING,
};
